module.exports = __webpack_public_path__ + "img/gallery08.7c5d4bc3.png";